var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.7805,
    cy: 20.7805,
    r: 20.7805,
    fill: "#BCBCBC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2143 21C14.5693 21 14.8571 20.7122 14.8571 20.3571C14.8571 20.0021 14.5693 19.7143 14.2143 19.7143C13.8592 19.7143 13.5714 20.0021 13.5714 20.3571C13.5714 20.7122 13.8592 21 14.2143 21Z",
    fill: "#F4F4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4286 12C16.0084 12 14.8571 13.1513 14.8571 14.5714V17.1429H13.5714C12.1513 17.1429 11 18.2941 11 19.7143V23.5714C11 24.9916 12.1513 26.1429 13.5714 26.1429H14.8571V27.4286C14.8571 28.8487 16.0084 30 17.4286 30H25.1429C26.563 30 27.7143 28.8487 27.7143 27.4286V26.1429H29C30.4202 26.1429 31.5714 24.9916 31.5714 23.5714V19.7143C31.5714 18.2941 30.4202 17.1429 29 17.1429H27.7143V14.5714C27.7143 13.1513 26.563 12 25.1429 12H17.4286ZM16.1429 14.5714C16.1429 13.8613 16.7185 13.2857 17.4286 13.2857H25.1429C25.8529 13.2857 26.4286 13.8613 26.4286 14.5714V17.1429H16.1429V14.5714ZM17.4286 21C16.0084 21 14.8571 22.1513 14.8571 23.5714V24.8571H13.5714C12.8613 24.8571 12.2857 24.2815 12.2857 23.5714V19.7143C12.2857 19.0042 12.8613 18.4286 13.5714 18.4286H29C29.7101 18.4286 30.2857 19.0042 30.2857 19.7143V23.5714C30.2857 24.2815 29.7101 24.8571 29 24.8571H27.7143V23.5714C27.7143 22.1513 26.563 21 25.1429 21H17.4286ZM26.4286 23.5714V27.4286C26.4286 28.1387 25.8529 28.7143 25.1429 28.7143H17.4286C16.7185 28.7143 16.1429 28.1387 16.1429 27.4286V23.5714C16.1429 22.8613 16.7185 22.2857 17.4286 22.2857H25.1429C25.8529 22.2857 26.4286 22.8613 26.4286 23.5714Z",
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.11a95c92c42dbb117e685c49ae01ebaa.svg";
export { ForwardRef as ReactComponent };